import { lazy } from 'react';

const NominationIntegrativeConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/integrative/consult/nomination-info',
			component: lazy(() => import('./NominationContainer'))
		}
	]
};

export default NominationIntegrativeConfig;



